import { Box } from '@src/atoms/Box';
import { Divider } from '@src/atoms/Divider';
import { Icon } from '@src/atoms/Icon';
import { Link } from '@src/atoms/Link';
import { Text } from '@src/atoms/Text';
import { AnyType } from '@src/models/common';
import React, { FC, useCallback } from 'react';
import { TFilter, TFilterSchemeOptions } from '../../models';

interface IMobileFiltersPropertyItemOption {
  option: AnyType;
  onClick: (option: AnyType, method: 'add' | 'remove') => void;
  value: boolean;
  filter: TFilter;
  isLast?: boolean;
}

/** Компонент элемента списка */
export const FiltersSwipeDialogOptionListItem: FC<IMobileFiltersPropertyItemOption> = ({
  onClick,
  option,
  value,
  isLast,
  filter,
}) => {
  const handleClick = useCallback(() => {
    onClick(option, value ? 'remove' : 'add');
  }, [onClick, option, value]);

  const { renderOption, filterField } = filter as TFilterSchemeOptions;

  return (
    <>
      <Box gap={8} fullWidth alignItems="center" justifyContent={'spaceBetween'} padding={16} onClick={handleClick}>
        <Link id="FilterPropertyOptionLink">
          <Text id="FilterPropertyOption" color="basicGreySemiDark" noOfLines={2}>
            {renderOption
              ? renderOption(option)
              : option?.[
                  //eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  filterField!
                ]}
          </Text>
        </Link>
        {value && <Icon name="check" view="labelOpenCabinet" size="sm" />}
      </Box>

      {!isLast && (
        <Box marginLeft={16} marginRight={16}>
          <Divider />
        </Box>
      )}
    </>
  );
};
